import { UnavailabilityType } from '../types'

const unavailabilityTypeToDisplayText: Record<UnavailabilityType, string> = {
  CALENDAR_INTEGRATION_BUSY: 'Integration showing busy',
  CALENDAR_INTEGRATION_NON_WORKING_HOURS: 'Outside integration work hours',
  EXISTING_APPOINTMENT: 'Existing appointment',
  NOT_WITHIN_COMPANY_WORKING_HOURS: 'Outside normal working hours',
  SCHEDULE_BLOCKED_FOR_ANOTHER_APPOINTMENT_TYPE: 'Blocked for other appointment type',
  SCHEDULE_BLOCKED_UNAVAILABLE: 'Blocked by unavailability constraint',
  SCHEDULE_NOT_DEFINED_UNAVAILABLE_BY_DEFAULT: 'Resource unavailable by default',
}

export { unavailabilityTypeToDisplayText }
